import React from 'react';
import Header from '../../Components/Header';


export default function HotelBooking() {
    return (
        <>
            <Header></Header>
            <section className='Booking_flight'>
            <div className='container_box'>
                <div className='row'>
                    <div className='col-md-9'>
                        <div className='box_shadow'>
                            <div class="row mamage_depo">
                                <div class="col-lg-6">
                                    <h3 className='sub_headings'>Review Your Booking</h3>
                                </div>
                                <div class="col-lg-6">
                                    <a href="/hotel/hoteldetail" class="click_back"><i class="fa fa-arrow-left"></i></a>
                                </div>
                                <div class="col-md-12">
                                    <div class="box-content">
                                        <div class="col-md-12">
                                            <h3 class="hotelNam">Fortune Sector 27, Noida - Member ITC Hotels Group</h3>
                                            <p class="p_detls">Block I Plot 1A Sector 27 Noida, Sector 27Noida 201301Uttar Pradesh, , Noida</p>
                                            <div class="start">
                                                <div class="five-stars-container">
                                                    <span class="four-stars"></span>
                                                </div>
                                            </div>

                                            <div class="row">
                                                <div class="col-md-7">
                                                    <div class="col-md-12 d-flex holding_booking">
                                                        <div class="box_date">
                                                            <label>Check In</label>
                                                            <div class="date">
                                                                <label class="month">Sep</label>
                                                                <label class="date">19</label>
                                                                <label class="day">Fri</label>
                                                            </div>
                                                        </div>
                                                        <div class="box_date">
                                                            <label>Check Out</label>
                                                            <div class="date">
                                                                <label class="month">Sep</label>
                                                                <label class="date">20</label>
                                                                <label class="day">Sat</label>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                                <div class="col-md-5">
                                                    <p class="chld_p">
                                                        Adults: 2 | Children: 0 | Room : 1 | Nights: 1
                                                    </p>
                                                    <h3 class="hotelNa">Deluxe Room (Deluxe Room),2 Twin Beds and 1 King Bed,NonSmoking</h3>
                                                </div>
                                            </div>



                                        </div>
                                        <div class="col-md-12">
                                            <h3 class="hotelN"> Tariff Inclusions</h3>
                                            <p class="tarrif_rt">(Free valet parking,Free self parking)</p>
                                        </div>


                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='box_shadow'>
                            <h3 className='sub_headings'>Enter Traveller Details</h3>
                            <div className="Traveller">
                                <h5>Contact Details</h5>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div class="form-group">
                                            <label class="">Email Address</label>
                                            <input class="form-control form-control-solid" name="" value="rahul.singh@transindiatechnologies.com" type="text" placeholder="." readOnly />
                                        </div>
                                    </div>
                                    <div className="col-md-5">
                                        <div class="form-group">
                                            <label class="required">Contact Number</label>
                                            <div className="d-flex">
                                                <div className="selct">
                                                    <select class="form-select form-select-solid">
                                                        <option defaultValue="">+91</option>
                                                        <option defaultValue="">+827</option>
                                                    </select>
                                                </div>
                                                <div className="inpt">
                                                    <input class="form-control form-control-solid" name="" type="text" placeholder="." />
                                                </div>
                                            </div>

                                        </div>
                                    </div>

                                    <p>Your booking details will sent to this email address and mobile number.</p>
                                </div>

                                <h5>Traveller Information</h5>
                                <p className="note"><span>Important Note :</span> Please ensure that the name of the passengers on the travel documents is the same on their government issued identity proof.</p>
                                <div className="row Adult">
                                    <div className="col-md-2">
                                        <h4 className="Adult">Adult 1</h4>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="d-flex">
                                            <div className="selct">
                                                <select class="form-select form-select-solid">
                                                    <option defaultValue="">Mr.</option>
                                                    <option defaultValue="">+827</option>
                                                </select>
                                            </div>
                                            <div className="inpt">
                                                <input class="form-control form-control-solid" name="" type="text" placeholder="First Name.." />
                                            </div>
                                        </div>

                                    </div>
                                    <div className="col-md-3">
                                        <input class="form-control form-control-solid" name="" type="text" placeholder="Last Name.." />
                                    </div>
                                    <div className="col-md-3">
                                        <input class="form-control form-control-solid" name="" type="text" placeholder="Date of Birth.." />
                                    </div>
                                    <div className="col-md-3">
                                        <div class="form-group">
                                            <label class="required">Passport No</label>
                                            <input class="form-control form-control-solid" name="" defaultValue="" type="text" placeholder="." />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div class="form-group">
                                            <label class="required">Issuing Country</label>
                                            <input class="form-control form-control-solid" name="" defaultValue="" type="text" placeholder="." />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div class="form-group">
                                            <label class="required">Nationality</label>
                                            <input class="form-control form-control-solid" name="" defaultValue="" type="text" placeholder="." />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div class="form-group">
                                            <label class="required">Issue Date</label>
                                            <input class="form-control form-control-solid" name="" defaultValue="" type="text" placeholder="." />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div class="form-group">
                                            <label class="required">Expiry Date</label>
                                            <input class="form-control form-control-solid" name="" defaultValue="" type="text" placeholder="." />
                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <div class="form-group">
                                            <label class="">Airline</label>
                                            <select class="form-select form-select-solid">
                                                <option value="Select">Select</option>
                                                <option value="I8">Aboriginal Air Services(I8)-</option>
                                                <option value="9B">AccessRail(9B)-</option>
                                                <option value="WZ">Acvila Air(WZ)-</option>
                                                <option value="KI">Adam Air(KI)-</option>
                                                <option value="Z7">ADC Airlines(Z7)-</option>
                                                <option value="JP">Adria Airways(JP)-</option>
                                                <option value="DF">Aebal(DF)-</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div class="form-group">
                                            <label class="required">Frequent Flyer No</label>
                                            <input class="form-control form-control-solid" name="" defaultValue="" type="text" placeholder="." />
                                        </div>
                                    </div>

                                    <div class="col-md-12 mt-5 mb-5">
                                        <div class="form-check form-check-inline">
                                            <input class="form-check-input" id="Active" name="Status" type="checkbox" value="1" />
                                            <label class="form-check-label" for="Active">Save/Update information for next booking.</label>
                                        </div>
                                    </div>
                                </div>

                                <div className="row Child">
                                    <div className="col-md-2">
                                        <h4 className="Adult">Child 1</h4>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="d-flex">
                                            <div className="selct">
                                                <select class="form-select form-select-solid">
                                                    <option defaultValue="">Mr.</option>
                                                    <option defaultValue="">+827</option>
                                                </select>
                                            </div>
                                            <div className="inpt">
                                                <input class="form-control form-control-solid" name="" type="text" placeholder="First Name.." />
                                            </div>
                                        </div>

                                    </div>
                                    <div className="col-md-3">
                                        <input class="form-control form-control-solid" name="" type="text" placeholder="Last Name.." />
                                    </div>
                                    <div className="col-md-3">
                                        <input class="form-control form-control-solid" name="" type="text" placeholder="Date of Birth.." />
                                    </div>
                                    <div className="col-md-3">
                                        <div class="form-group">
                                            <label class="required">Passport No</label>
                                            <input class="form-control form-control-solid" name="" defaultValue="" type="text" placeholder="." />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div class="form-group">
                                            <label class="required">Issuing Country</label>
                                            <input class="form-control form-control-solid" name="" defaultValue="" type="text" placeholder="." />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div class="form-group">
                                            <label class="required">Nationality</label>
                                            <input class="form-control form-control-solid" name="" defaultValue="" type="text" placeholder="." />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div class="form-group">
                                            <label class="required">Issue Date</label>
                                            <input class="form-control form-control-solid" name="" defaultValue="" type="text" placeholder="." />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div class="form-group">
                                            <label class="required">Expiry Date</label>
                                            <input class="form-control form-control-solid" name="" defaultValue="" type="text" placeholder="." />
                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <div class="form-group">
                                            <label class="">Airline</label>
                                            <select class="form-select form-select-solid">
                                                <option value="Select">Select</option>
                                                <option value="I8">Aboriginal Air Services(I8)-</option>
                                                <option value="9B">AccessRail(9B)-</option>
                                                <option value="WZ">Acvila Air(WZ)-</option>
                                                <option value="KI">Adam Air(KI)-</option>
                                                <option value="Z7">ADC Airlines(Z7)-</option>
                                                <option value="JP">Adria Airways(JP)-</option>
                                                <option value="DF">Aebal(DF)-</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div class="form-group">
                                            <label class="required">Frequent Flyer No</label>
                                            <input class="form-control form-control-solid" name="" defaultValue="" type="text" placeholder="." />
                                        </div>
                                    </div>

                                    <div class="col-md-12 mt-5 mb-5">
                                        <div class="form-check form-check-inline">
                                            <input class="form-check-input" id="Active" name="Status" type="checkbox" value="1" />
                                            <label class="form-check-label" for="Active">Save/Update information for next booking.</label>
                                        </div>
                                    </div>
                                </div>

                                <div className="row Infant">
                                    <div className="col-md-2">
                                        <h4 className="Adult">Infant 1</h4>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="d-flex">
                                            <div className="selct">
                                                <select class="form-select form-select-solid">
                                                    <option defaultValue="">Mr.</option>
                                                    <option defaultValue="">+827</option>
                                                </select>
                                            </div>
                                            <div className="inpt">
                                                <input class="form-control form-control-solid" name="" type="text" placeholder="First Name.." />
                                            </div>
                                        </div>

                                    </div>
                                    <div className="col-md-3">
                                        <input class="form-control form-control-solid" name="" type="text" placeholder="Last Name.." />
                                    </div>
                                    <div className="col-md-3">
                                        <input class="form-control form-control-solid" name="" type="text" placeholder="Date of Birth.." />
                                    </div>
                                    <div className="col-md-3">
                                        <div class="form-group">
                                            <label class="required">Passport No</label>
                                            <input class="form-control form-control-solid" name="" defaultValue="" type="text" placeholder="." />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div class="form-group">
                                            <label class="required">Issuing Country</label>
                                            <input class="form-control form-control-solid" name="" defaultValue="" type="text" placeholder="." />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div class="form-group">
                                            <label class="required">Nationality</label>
                                            <input class="form-control form-control-solid" name="" defaultValue="" type="text" placeholder="." />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div class="form-group">
                                            <label class="required">Issue Date</label>
                                            <input class="form-control form-control-solid" name="" defaultValue="" type="text" placeholder="." />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div class="form-group">
                                            <label class="required">Expiry Date</label>
                                            <input class="form-control form-control-solid" name="" defaultValue="" type="text" placeholder="." />
                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <div class="form-group">
                                            <label class="">Airline</label>
                                            <select class="form-select form-select-solid">
                                                <option value="Select">Select</option>
                                                <option value="I8">Aboriginal Air Services(I8)-</option>
                                                <option value="9B">AccessRail(9B)-</option>
                                                <option value="WZ">Acvila Air(WZ)-</option>
                                                <option value="KI">Adam Air(KI)-</option>
                                                <option value="Z7">ADC Airlines(Z7)-</option>
                                                <option value="JP">Adria Airways(JP)-</option>
                                                <option value="DF">Aebal(DF)-</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div class="form-group">
                                            <label class="required">Frequent Flyer No</label>
                                            <input class="form-control form-control-solid" name="" defaultValue="" type="text" placeholder="." />
                                        </div>
                                    </div>

                                    <div class="col-md-12 mt-5 mb-5">
                                        <div class="form-check form-check-inline">
                                            <input class="form-check-input" id="Active" name="Status" type="checkbox" value="1" />
                                            <label class="form-check-label" for="Active">Save/Update information for next booking.</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                       
                            <h3 className='sub_headings'>Cancellation Policy</h3>
                            <p>This is under cancellation booking and would attract cancellation charges.</p>
                            <p>To avoid cancellation charges the booking must be cancelled on or before : 18 Sep 2025</p>
                            <ul>
                                <li>To avoid cancellation charges the booking must be cancelled on or before : 18 Sep 2025</li>
                            </ul>
                            <h3 className='sub_headings'>Hotel Info</h3>
                            <h5>RateConditions</h5>
                            <ul>
                                <li>Early check out will attract full cancellation charge unless otherwise
                                    specified.</li>
                                <li>Default Check In Time :12:00:00.</li>
                                <li>Default Check Out Time :11:00:00.</li>
                            </ul>

                            <div className='col-md-12 text-end'>
                                <div class="button-list">
                                    <a class="btn-btn-border" href="/hotel/hoteldetail">Back To Result</a>
                                    <a class="btn btn-primary contnt" href="/hotel/CheckOut">Make Payment</a>
                                    {/* <button class="btn btn-primary">Make Payment</button> */}
                                    </div>
                            </div>
                        </div>
                       

                    </div>
                      <div className='col-md-3'>
              <div className='box_shadow'>
                <h6>Fare Summary</h6>
                <div class="accordion" id="kt_accordion_1">
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="kt_accordion_1_header_1">
                      <button class="accordion-button fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#kt_accordion_1_body_1" aria-expanded="true" aria-controls="kt_accordion_1_body_1">
                        <div className='flex'>
                          <span> Base Fare</span>
                          <span><i className='fa fa-inr'></i> 5648</span>
                        </div>
                      </button>
                    </h2>
                    <div id="kt_accordion_1_body_1" class="accordion-collapse collapse show" aria-labelledby="kt_accordion_1_header_1" data-bs-parent="#kt_accordion_1">
                      <div class="accordion-body">
                        <div className='flex'>
                          <span> Adult(s)</span>
                          <span><i className='fa fa-inr'></i> 5648</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="accordion-item">
                    <h2 class="accordion-header" id="kt_accordion_1_header_2">
                      <button class="accordion-button fw-semibold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#kt_accordion_1_body_2" aria-expanded="false" aria-controls="kt_accordion_1_body_2">
                        <div className='flex'>
                          <span>Fee & Surcharges</span>
                          <span> <i className='fa fa-inr'></i> 5648</span>
                        </div>
                      </button>
                    </h2>
                    <div id="kt_accordion_1_body_2" class="accordion-collapse collapse" aria-labelledby="kt_accordion_1_header_2" data-bs-parent="#kt_accordion_1">
                      <div class="accordion-body">
                        <div className='flex'>
                          <span> Fuel Surcharge</span>
                          <span><i className='fa fa-inr'></i> 5648</span>
                        </div>
                        <div className='flex'>
                          <span> Tax</span>
                          <span><i className='fa fa-inr'></i> 5648</span>
                        </div>
                        <div className='flex'>
                          <span> Booking Surcharge</span>
                          <span><i className='fa fa-inr'></i> 5648</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="accordion-item">
                    <h2 class="accordion-header" id="kt_accordion_1_header_3">
                      <button class="accordion-button fw-semibold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#kt_accordion_1_body_3" aria-expanded="false" aria-controls="kt_accordion_1_body_3">
                        <div className='flex'>
                          <span>Total Fare</span>
                          <span><i className='fa fa-inr'></i> 5648</span>
                        </div>
                      </button>
                    </h2>
                    <div id="kt_accordion_1_body_3" class="accordion-collapse collapse" aria-labelledby="kt_accordion_1_header_3" data-bs-parent="#kt_accordion_1">
                      <div class="accordion-body">
                        <div className='flex'>
                          <span> Markup</span>
                          <span><i className='fa fa-inr'></i> 5648</span>
                        </div>
                        <div className='flex'>
                          <span> Commission</span>
                          <span><i className='fa fa-inr'></i> 5648</span>
                        </div>
                        <div className='flex'>
                          <span> Net Fare</span>
                          <span><i className='fa fa-inr'></i> 5648</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='d-flexes'>
                  <div className='totals'>GRAND TOTAL</div>
                  <div className='tolt_price'><i className='fa fa-inr'></i> 8797</div>
                </div>
              </div>
            </div>
                </div>
            </div>
</section>



        </>


    )
};
